export function getOS() {
  try {
    return navigator.platform || ((navigator as any).userAgentData?.platform as string) || 'unkown';
  } catch (error) {
    return 'unkown';
  }
}
